import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import useAddress from "./useAddress";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const { reset, handleSubmit, setErrors, setData, addressFields } = useAddress();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('towns').then(res => {
      setData({ data: res?.data });
    });
  }, []);

  const addAddress = data => {
    data.user_id = id;
    axios.post('customerAddresses/create', data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Address has been created successfully!', {
            icon: "success",
          });
          navigate("/customers/" + id);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add address">
      <form className="form w-100 row" onSubmit={handleSubmit(addAddress)}>
        {addressFields}
        <div className="col-12 mt-10">
          <SubmitButton
            title="Add"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}